"use client";

import React from "react";

//Styles
import * as S from "./styles";

interface ListEvenOddProps {
  data: any[];
  renderItem: (item: any, index: number) => React.ReactNode;
}

const ListEvenOdd: React.FC<ListEvenOddProps> = ({ data, renderItem }) => {
  return (
    <S.List>
      {data.map((item, index) => (
        <S.ListItem key={index}>{renderItem(item, index)}</S.ListItem>
      ))}
    </S.List>
  );
};

export default ListEvenOdd;
